/*jslint browser:true, node: true */
'use strict';

var glslify = require('glslify');

var ParticleShader = function(options) {

  options = options || {};

  var params = {

    opacity: 1,
    transparent: true,
    blending: 1,
    depthTest: false,
    depthWrite: false,

    side: options.side !== undefined ? options.side : 0,

    shading: options.shading || THREE.SmoothShading,

    uniforms: {

      opacity: { type: 'f', value: options.opacity || 0.6 },

      radius: { type: 'f', value: 1.0 },

      radScl: { type: 'f', value: window.devicePixelRatio },

      uNormal: {
        type: 'v3',
        value: options.normal || new THREE.Vector3(0, 1, 0) },

    },

    vertexShader: glslify('./ParticleShader.vert'),

    fragmentShader: glslify('./ParticleShader.frag'),
  };

  THREE.ShaderMaterial.call(this, params);
};


/**
 * @extends {THREE.ShaderMaterial}
 */
ParticleShader.prototype = Object.create(
    THREE.ShaderMaterial.prototype);


/**
 * common js
 */
module.exports = ParticleShader;
